import React, { useState, useEffect } from 'react';
import axios from 'axios';

const loadingPhrases = [
    'Analyzing your binge-watching habits...',
    'Compiling your top genres...',
    'Calculating your total screen time...',
    'Deploying your personalized recap...'
];

const FileUpload = ({ onDataReceived }) => {
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [progress, setProgress] = useState(0);
    const [phraseIndex, setPhraseIndex] = useState(0);

    useEffect(() => {
        let progressTimer;
        let phraseTimer;

        if (loading) {
            setProgress(0);
            setPhraseIndex(0);

            progressTimer = setInterval(() => {
                setProgress(oldProgress => {
                    if (oldProgress >= 95) { // Stop just before 100%
                        return 95;
                    }
                    const diff = Math.random() * 5;
                    return Math.min(oldProgress + diff, 95);
                });
            }, 400);

            phraseTimer = setInterval(() => {
                setPhraseIndex(oldIndex => (oldIndex + 1) % loadingPhrases.length);
            }, 2000);
        }

        return () => {
            clearInterval(progressTimer);
            clearInterval(phraseTimer);
        };
    }, [loading]);

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleUpload = async () => {
        if (!file) {
            setError('Please select a file first.');
            return;
        }
        setLoading(true);
        setError('');
        const formData = new FormData();
        formData.append('file', file);

        try {
            const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
            const res = await axios.post(`${apiUrl}/api/upload`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            setProgress(100);
            setTimeout(() => {
                onDataReceived(res.data);
            }, 1000); // Show 100% for a moment before transitioning
        } catch (err) {
            setError('Error uploading file. Please try again.');
            console.error(err);
            setLoading(false);
        }
    };

    return (
        <div className="upload-container">
            <div className="upload-box">
                <h2 className="upload-title">Your Netflix Recap</h2>
                <p className="upload-subtitle">Upload your viewing activity to unwrap your stats.</p>
                
                {!loading ? (
                    <>
                        <label htmlFor="file-upload" className="upload-label">
                            Select Viewing Activity File
                        </label><br></br>
                        <input id="file-upload" type="file" onChange={handleFileChange} accept=".csv" />
                        {file && <p className="file-name">Selected: {file.name}</p>}
                        <button onClick={handleUpload} disabled={!file} className="upload-button">
                            Unwrap
                        </button>
                    </>
                ) : (
                    <div className="progress-container">
                        <p>{loadingPhrases[phraseIndex]}</p>
                        <div className="progress-bar">
                            <div className="progress-bar-inner" style={{ width: `${progress}%` }}></div>
                        </div>
                    </div>
                )}
                
                {error && <p className="error">{error}</p>}
            </div>
            <p style={{ textAlign: 'center', marginTop: '1rem' }}>
                <a href="https://help.netflix.com/en/node/101917" target="_blank" rel="noopener noreferrer" style={{ fontSize: '0.8rem', color: '#a0a0a0' }}>
                    How to download viewing activity?
                </a>
            </p>
        </div>
    );
};

export default FileUpload;
